import { Region } from 'types/model';
import { patchPathname } from './patch-pathname';

export const getRegionsWithPagePathname = (regions: Region[], pagePathname: string): Region[] => {
  return regions.map((region) => {
    const base = new URL(region.currentPageLink);
    base.pathname = patchPathname(pagePathname);
    return {
      ...region,
      currentPageLink: decodeURIComponent(base.href),
    };
  });
};
